
import {finalize} from 'rxjs/operators';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { AppService } from '../../app.service';
import { NotificationsService } from '../notifications.service';
import { NotificationsComponent } from '../notifications.component';
import { NotificationItemModel } from '../../shared/notification/notification-item/notification-item.model';
import { PatientsService } from '../../patients/patients.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { PopoverService } from '../../shared/popover/popover.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-notifications-details',
    templateUrl: 'details.component.html',
    styleUrls: ['details.component.scss'],
    providers: [
        NotificationsService,
        PatientsService
    ]
})

export class NotificationDetailsComponent extends NotificationsComponent implements OnInit {
    @ViewChild('dialog', { static: false }) dialog: DialogComponent;

    @Input() selectedNotification: NotificationItemModel;

    successMessage = '';
    displayMsg = false;
    displayContent = '';
    displayParams = {};
    datePipe: DatePipe = new DatePipe('en-US');

    timeoutId: any;

    constructor(
        public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public appService: AppService,
        public patientsService: PatientsService,
        public route: ActivatedRoute,
        public popoverService: PopoverService,
        public translateService: TranslateService,
        private notificationsService: NotificationsService
    ) {
        super(authService, router, baseService, appService, popoverService, route, translateService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.route.params.subscribe(params => {
            this.clearMsgInfo();
        });

    }

    get isRemoveAction() {
        if (!this.selectedNotification.isUserProfileLink || this.selectedNotification.params['deleted_users'].length === 0) {
            return false;
        }

        return true;
    }

    acceptTransfer() {
        if (!this.selectedNotification.transferPatientId) {
            return;
        }

        this.patientsService.submitTransferdPatient(true, this.selectedNotification.transferPatientId)
            .subscribe(
                res => {
                    this.appService.fetchUnreadNotification();
                },
                err => this.handlerError());
    }

    denyTransfer() {
        if (!this.selectedNotification.transferPatientId) {
            return;
        }

        this.patientsService.submitTransferdPatient(false, this.selectedNotification.transferPatientId)
            .subscribe(
                res => {
                    this.appService.fetchUnreadNotification();
                },
                err => this.handlerError());
    }

    startTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
            this.clearMsgInfo();
        }, 5000);
    }

    clearMsgInfo() {
        this.displayMsg = false;
        this.displayContent = '';
        this.displayParams = {};
    }

    doDefaultAction() {
        if (!this.selectedNotification) {
            return;
        }
        if (!this.selectedNotification.isClickable) {
            this.displayContent = this.selectedNotification.msgContent;
            this.displayParams = this.selectedNotification.msgParams;
            if (this.displayParams['date']) {
                const format = 'dd.MM.y';
                this.displayParams['date'] = this.datePipe.transform(this.displayParams['date'], format);
            }
            this.displayMsg = true;
            this.startTimeout();
            return;
        }
        if (this.selectedNotification.redirectUrl) {
            this.router.navigateByUrl(this.selectedNotification.redirectUrl);
        }
    }

    deleteNotification() {
        if (!this.selectedNotification) {
            return;
        }

        this.successMessage = '';

        this.notificationsService.deleteNotification(this.selectedNotification.id).pipe(
            finalize(() => this.appService.fetchUnreadNotification()))
            .subscribe(
                res => {
                    this.successMessage = res['message'];
                    setInterval(() => this.successMessage = '', 3000);
                });
    }

    private handlerError() {
        const alert = this.dialog.openAlert({
            icon: 'fas fa-exclamation-triangle'
        });

        alert.showAlert('Warning: Request has been withdrawn or Patient has been transferred to another doctor!');
    }

}
